/**
 * Build a message to be populated in a tooltip if the select is disabled
 *
 * @param {boolean} loading
 * @param {boolean} error
 * @param {Array<{id: string, name: string}>} integrations
 * @returns {string | null} The disabled message
 */
export default function buildIntegrationSelectDisabledMessage({ loading, error, integrations }) {
  const isNotDisabled = !loading && !error && integrations?.length;
  if (isNotDisabled) {
    return null;
  }

  if (loading) {
    return 'Loading integrations...';
  }

  if (error) {
    return 'Error loading integrations';
  }

  return 'No integrations configured';
}
